import { ErrorMessageType } from "@/types/error";

interface ErrorToastProps {
  errorMessage: ErrorMessageType;
}

function ErrorToast({
  errorMessage: { description, action },
}: ErrorToastProps) {
  return (
    <div>
      <h6 className="text-16 font-bold">{description}</h6>
      <p className="text-14">{action}</p>
    </div>
  );
}

export default ErrorToast;
